module.exports = __webpack_public_path__ + "assets/img/7july_dark.7b5b8775.jpeg";